import { render, staticRenderFns } from "./tool.vue?vue&type=template&id=47c028b1"
import script from "./tool.vue?vue&type=script&lang=js"
export * from "./tool.vue?vue&type=script&lang=js"
import style0 from "./tool.vue?vue&type=style&index=0&id=47c028b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports